import { createFileRoute, useSearch } from "@tanstack/react-router"
import { LogoFull } from "@/components/LogoFull"
import { useEffect, useState } from "react"
import { CheckCircle, LoaderCircle } from "lucide-react"
import { ErrorCard } from "@/components/ErrorCard.tsx"
import { useMutation } from "@tanstack/react-query"
import { authApi } from "@/api/auth.api.ts"
import { Button } from "@/components/ui/button.tsx"
import { usePageTitle } from "@/contexts/PageTitleContext.tsx"
import { useTranslation } from "react-i18next"

export const Route = createFileRoute("/_unauthorized/account/confirm-email")({
  component: RouteComponent,
})

function RouteComponent() {
  const { c }: { c: string } = useSearch({
    from: "/_unauthorized/account/confirm-email",
  })
  const { t } = useTranslation()
  const { setTitle } = usePageTitle()
  const [isVerifying, setIsVerifying] = useState(true)
  const [isVerified, setisVerified] = useState(false)
  const [error, setError] = useState(false)

  if (!c) {
    return (
      <div className="flex h-full w-full max-w-md flex-col items-center p-4 text-center">
        <div className="mt-4 mb-4">
          <img src={LogoFull} alt="Egab" />
        </div>
        <ErrorCard />
      </div>
    )
  }

  const verifyEmail = useMutation({
    mutationFn: authApi.verifyEmail,
    onSuccess: () => {
      setIsVerifying(false)
      setisVerified(true)
    },
    onError: () => {
      setIsVerifying(false)
      setError(true)
    },
  })

  useEffect(() => {
    setTitle("Verify Email")
    if (c) {
      verifyEmail.mutate(c)
    }
  }, [c])

  return (
    <div className="flex h-full w-full max-w-md flex-col items-center p-4 text-center">
      <LogoFull />
      {isVerifying && (
        <div className="m-8 flex flex-col items-center gap-4 text-center font-heading text-lg">
          <LoaderCircle size="48" className="animate-spin" />
          {t("confirmEmail.verifying")}
        </div>
      )}
      {!isVerifying && isVerified && (
        <div className="m-8 flex flex-col items-center gap-4 text-center font-heading text-lg">
          <CheckCircle size="48" />
          {t("confirmEmail.verified")}
          <div
            className="m-8 font-sans"
            onClick={() => {
              window.location.replace("/login")
            }}
          >
            <Button type="button" size="lg">
              {t("auth.login")}
            </Button>
          </div>
        </div>
      )}
      {!isVerifying && error && <ErrorCard isRefresh />}
    </div>
  )
}
